const pad = (value) => {
  if (value < 10) {
    return '0' + value;
  } else {
    return value;
  }
}

const monthAsString = (value) => {
  switch (value) {
    case 0: return 'Jan'
    case 1: return 'Feb'
    case 2: return 'Mar'
    case 3: return 'Apr'
    case 4: return 'May'
    case 5: return 'Jun'
    case 6: return 'Jul'
    case 7: return 'Aug'
    case 8: return 'Sep'
    case 9: return 'Oct'
    case 10: return 'Nov'
    case 11: return 'Dec'
    default: throw Error('Invalid month value ' + value + ". Should be [0,11].")
  }
}

const formatDateSince = (date) => {

  const now = Date.now()
  const elapsed =  now - date

  const numSec = Math.round(elapsed / (1000))
  if (numSec < 60) {
    return numSec + " sec"
  }

  const numMin = Math.round(elapsed / (60 * 1000))
  if (numMin < 5) {
    return numMin + " min"
  }

  const numHours = Math.round(elapsed / (60 * 60 * 1000))
  if (numHours < 24) {
    return pad(date.getHours()) + ':' + pad(date.getMinutes())
  }

  const numDays = Math.round(elapsed / (24 * 60 * 60 * 1000))
  if (numDays < 365) {
    return date.getDate() + ' '
    + monthAsString(date.getMonth()) + ' '
    + pad(date.getHours()) + ':' + pad(date.getMinutes())
  }

  return date.toISOString()
}

export { formatDateSince }



// WEBPACK FOOTER //
// ./src/format-date.js